/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateSalesInvoicePositionDto } from './CreateUpdateSalesInvoicePositionDto';
import {
    CreateUpdateSalesInvoicePositionDtoFromJSON,
    CreateUpdateSalesInvoicePositionDtoFromJSONTyped,
    CreateUpdateSalesInvoicePositionDtoToJSON,
} from './CreateUpdateSalesInvoicePositionDto';

/**
 * 
 * @export
 * @interface CreateUpdateSalesInvoicePositionsDto
 */
export interface CreateUpdateSalesInvoicePositionsDto {
    /**
     * 
     * @type {Array<CreateUpdateSalesInvoicePositionDto>}
     * @memberof CreateUpdateSalesInvoicePositionsDto
     */
    positions: Array<CreateUpdateSalesInvoicePositionDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoicePositionsDto
     */
    salesInvoiceId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoicePositionsDto
     */
    salesInvoiceTs?: Date | null;
}

/**
 * Check if a given object implements the CreateUpdateSalesInvoicePositionsDto interface.
 */
export function instanceOfCreateUpdateSalesInvoicePositionsDto(value: object): value is CreateUpdateSalesInvoicePositionsDto {
    if (!('positions' in value) || value['positions'] === undefined) return false;
    if (!('salesInvoiceId' in value) || value['salesInvoiceId'] === undefined) return false;
    return true;
}

export function CreateUpdateSalesInvoicePositionsDtoFromJSON(json: any): CreateUpdateSalesInvoicePositionsDto {
    return CreateUpdateSalesInvoicePositionsDtoFromJSONTyped(json, false);
}

export function CreateUpdateSalesInvoicePositionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSalesInvoicePositionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'positions': ((json['positions'] as Array<any>).map(CreateUpdateSalesInvoicePositionDtoFromJSON)),
        'salesInvoiceId': json['salesInvoiceId'],
        'salesInvoiceTs': json['salesInvoiceTs'] == null ? undefined : (new Date(json['salesInvoiceTs'])),
    };
}

export function CreateUpdateSalesInvoicePositionsDtoToJSON(value?: CreateUpdateSalesInvoicePositionsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'positions': ((value['positions'] as Array<any>).map(CreateUpdateSalesInvoicePositionDtoToJSON)),
        'salesInvoiceId': value['salesInvoiceId'],
        'salesInvoiceTs': value['salesInvoiceTs'] == null ? undefined : ((value['salesInvoiceTs'] as any).toISOString()),
    };
}

